import React, { useEffect, useState, lazy, Suspense } from "react";
import Header from "./Header";
import $ from "jquery";
import RemoveOrderModal from "./reusable/RemoveOrderModal";
import {
  useNavigate,
  useSearchParams,
  useParams,
} from "react-router-dom";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CustomPINDisplay from "./reusable/CustomPINDisplay";
import Footer from "./Footer";
import MapboxRobot from "./MapboxRobot";
import Instruction from "../modals/Instruction";
import { ORDER_STATUS_CODE } from "../constants/enums";
import CustomProgressBar from "./reusable/CustomProgressBar";
import { cancelOrder } from "../API";
import { toast } from "react-toastify";
const Watchvideo = lazy(() => import("../modals/Watchvideo"));

function Congratulations({
  maxBoundCordinates,
  orderDetails,
  otp,
  eta,
  etaLoader,
  isLoading,
}) {
  const [openRemoveOrderModal, setOpenRemoveOrderModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { orderID } = useParams();
  const [open, setOpen] = React.useState(false);
  const [openthree, setopenthree] = useState(false);
  const [opentwo, setOpentwo] = React.useState(false);
  const navigate = useNavigate();
  const [inputOTP, setInputOTP] = useState("");
  const handleOpenthree = () => setopenthree(true);
  const [openfour, setopenfour] = React.useState(false);
  const [progressBar, setProgressBar] = useState(0);
  const primaryColor = process.env.REACT_APP_PRIMARY_COLOR || "#00A16F";
  const secondaryColor = process.env.REACT_APP_SECONDARY_COLOR || "#D9FAF1";
  const handleOpenfour = () => {
    setopenfour(true);
  };
  const deleteOrder = async (id) => {
    try {
      const deleteAction = await cancelOrder(orderDetails.fleetId, id);
      console.log(deleteAction);
      toast.success(deleteAction.data.message);
    } catch (err) {
      toast.error(err.message);
    }
  };
  var rString = "";

  const loaderContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "10vh",
  };

  const loaderStyle = {
    border: "4px solid rgba(0, 0, 0, 0.1)",
    borderTop: "4px solid #000",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    animation: "spin 1s linear infinite",
  };

  const keyframesAnimation = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 350,
    bgcolor: "#ffffff",
    boxShadow: 24,
    p: 4,
    borderRadius: "10px",
    paddingTop: "11px",
    paddingBottom: "0px",
    border: "none",
    paddingRight: "0px",
    paddingLeft: "0px",
    zIndex: "999999999999999999999999",
  };

  const handleClose = (reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false);
  };

  const handleClosetwo = (reason) => {
    if (reason && reason === "backdropClick") return;
    setOpentwo(false);
  };

  const handleOpen = () => setOpen(true);

  const handleopentwo = () => setOpentwo(true);
  let mapheight = "327px";

  useEffect(() => {
    if (document.getElementById("Estimated_time")) {
      var offsetHeight = document.getElementById("Estimated_time").offsetHeight;
    }

    mapheight = mapheight - offsetHeight + "px";
  }, [mapheight, otp]);

  function generateBarCode(qrcode) {
    var url =
      "https://api.qrserver.com/v1/create-qr-code/?data=" +
      qrcode +
      "&amp;size=50x50";
    $("#barcode").attr("src", url);
    return rString;
  }
  useEffect(() => {
    const progressBarPercentage = (currentEta) => {
      let etaToBeShown = process.env.REACT_APP_ONLYPICKUP ? eta?.pickupEta : eta?.totalEta;
      if (orderDetails?.statusCode >= ORDER_STATUS_CODE.PICKED_UP) {
        etaToBeShown = eta?.totalEta;
      }
      if (orderDetails?.statusCode > ORDER_STATUS_CODE.EN_ROUTE_DROP_OFF) {
        return 100;
      }
      if (isNaN(etaToBeShown)) {
        return currentEta;
      }
      if (etaToBeShown === 0) {
        return 100;
      }
      if (!orderDetails?.ETA) {
        return 50;
      }
      let calcPercentage =
        ((orderDetails?.ETA - etaToBeShown) / orderDetails?.ETA) * 100;
      if (calcPercentage < 0) {
        return 0;
      }
      if (calcPercentage > 100) {
        return 100;
      }
      return calcPercentage;
    };

    // const orderFlag = () => {
    //   let flag;
    //   let timeTakenByTheOrder =
    //     (new Date() - new Date(orderDetails.order_dispatched)) / 1000.0;
    //   let timeDiff = orderDetails?.ETA - timeTakenByTheOrder;
    //   if (timeDiff >= 0) {
    //   } else {
    //   }
    // };
    const currentProgress = progressBarPercentage(progressBar);
    setProgressBar(currentProgress);
  }, [eta, orderDetails]);

  const getorderpage = (orderDetails) => {
    if (!!Number(process.env.REACT_APP_ONLYPICKUP)) {
      if (orderDetails.statusCode > ORDER_STATUS_CODE.PICKED_UP) {
        if (orderDetails.statusCode === ORDER_STATUS_CODE.CANCELLED_BEFORE_PICKUP || orderDetails.statusCode === ORDER_STATUS_CODE.CANCELLED_AFTER_PICKUP_BEFORE_DELIVERY || orderDetails.statusCode === ORDER_STATUS_CODE.CANCELLED_ALT) {
          navigate("/ordercancel", { state: { orderDetails, orderID } });
        } else {
          navigate("/orderpickedup", { state: { orderDetails, orderID } });
        }
      }
    } else {
      if (orderDetails?.orderStatus === "Order is delivered (Complete)") {
        navigate("/orderdelivered", { state: { orderDetails, orderID } });
      } else if (orderDetails?.statusCode === "Order is Cancelled") {
        navigate("/ordercancel", { state: { orderDetails, orderID } });
      }
    }
  };
  const orderEtaText = (order) => {
    if (!order && process.env.REACT_APP_STORE_NAME) return `Waiting for ${process.env.REACT_APP_STORE_NAME ?? "The Store"} to accept your order`;
    if (!!Number(process.env.REACT_APP_ONLYPICKUP) && order?.statusCode < ORDER_STATUS_CODE.PICKED_UP && !isNaN(eta?.pickupEta) && eta?.pickupEta > 0) return `Pickup in ${Math.ceil(eta?.pickupEta / 60) ?? 0} mins`;
    else {
      if (order?.statusCode === ORDER_STATUS_CODE.REACHED_DROP_OFF || eta?.totalEta === 0) return `Reached ${order?.orderDropLocation?.locationName}`;
      if (order?.statusCode === ORDER_STATUS_CODE.WAITING_FOR_DROP_OFF) return `Waiting at ${order?.orderDropLocation?.locationName}`;
      if (isNaN(eta?.totalEta)) return "...";
      if ([ORDER_STATUS_CODE.EN_ROUTE_PICKUP, ORDER_STATUS_CODE.REACHED_PICKUP, ORDER_STATUS_CODE.WAITING_FOR_PICKUP, ORDER_STATUS_CODE.PICKED_UP, ORDER_STATUS_CODE.EN_ROUTE_DROP_OFF].includes(order?.statusCode) && eta?.totalEta > 0) return `Delivery in ${Math.ceil(eta?.totalEta / 60) ?? 0} mins`;
    }
    return "";
  }
  const handleKeyDown = (event) => {
    event.preventDefault();
  };
  return (
    <>
      <div className="w-full mx-auto flex flex-col border-t-0 h-screen">
        <Header orderDetails={orderDetails} open={open} opentwo={opentwo} />
        <div className="overflow-auto h-[calc(100vh-11rem)]">
          <div className="flex flex-col h-full">
            <div
              className="h-1/2 bg-white [&_h3]:opacity-30"
              id="mapDiv"
            >
              {orderDetails?.orderDropLocation?.positionY === undefined ||
                orderDetails?.orderDropLocation?.positionX === undefined ||
                orderDetails?.orderPickupLocation?.positionY === undefined ||
                orderDetails?.orderPickupLocation?.positionX === undefined ||
                orderDetails?.orderStatus === "Order is Cancelled" ||
                (orderDetails?.orderStatus ===
                  "Order is delivered (Complete)" &&
                  getorderpage(orderDetails))}
              {Object.keys(maxBoundCordinates).length ? (
                <MapboxRobot
                  orderDetails={orderDetails}
                  maxBoundCordinates={maxBoundCordinates}
                  orderDropLocation={orderDetails?.orderDropLocation}
                  orderPickupLocation={orderDetails?.orderPickupLocation}
                  robotLocation={orderDetails?.robotLocation}
                />
              ) : null}
            </div>
            <div className="flex flex-col gap-y-3 rounded-t-full py-3 px-4">
              <div className="flex flex-col gap-y-2">
                <div className="flex justify-center">
                  <p className="font-bold self-center text-base">
                    {orderEtaText(orderDetails)}
                  </p>
                  {/* <div>
                    {!orderDetails&&(
                      <div></div>
                    )}
                  </div> */}
                  {orderDetails?.statusCode < ORDER_STATUS_CODE.PICKED_UP && !!Number(process.env.REACT_APP_SHOW_PICKUP_CANCEL) && (
                    <button
                      className="text-xs text-white p-2 bg-accent font-bold rounded"
                      onClick={() => setOpenRemoveOrderModal(true)}
                    >
                      Cancel Pickup
                    </button>
                  )
                  }
                </div>
                {orderDetails?.robotId &&
                  <CustomProgressBar value={progressBar} />
                }
              </div>
              {orderDetails?.pin&&(
              <div>
                <p className="text-xl font-bold">PIN to access Cabin</p>
                <div className="flex justify-center mt-2">
                  <CustomPINDisplay
                    value={sessionStorage.getItem("pin")}
                    inputClassName="readonly-input rounded-[5px] font-extrabold border border-gray-400"
                    onChange={setInputOTP}
                    OTPLength={sessionStorage.getItem("pin")?.length ?? 4}
                    onKeyDown={handleKeyDown}
                    otpType="number"
                    disabled={false}
                    className="flex justify-center"
                  />
                </div>
              </div>
              )}
              <div className="flex border border-[#E6E6E6] py-3 px-2 gap-x-2 rounded w-full">
                <div className="bg-[#F1F0F5] py-1.5 px-3 rounded flex">
                  <svg
                    className="self-center"
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="32.956"
                    viewBox="0 0 15 32.956"
                  >
                    <g
                      id="noun-info-2096294"
                      transform="translate(-222.749 -0.058)"
                    >
                      <path
                        id="Path_85"
                        data-name="Path 85"
                        d="M233.156,146.716c2.733,0,4.074,1.742,3.293,4.627-.557,2.088-1.363,4.113-2.1,6.151-.813,2.266-1.676,4.518-2.5,6.78a6.843,6.843,0,0,0-.365,1.475,1,1,0,0,0,.244.813.938.938,0,0,0,.843,0,6.254,6.254,0,0,0,1.35-1.034c.846-.86,1.646-1.782,2.466-2.654.247-.26.5-.724.988-.418a.863.863,0,0,1,.171,1.281,12.978,12.978,0,0,1-1.291,1.821,15.992,15.992,0,0,1-7.9,5.216,4.922,4.922,0,0,1-2.914.079h0a2.8,2.8,0,0,1-1.367-.915,3.229,3.229,0,0,1-.514-2.164,6.291,6.291,0,0,1,.389-2.088s1.1-2.914,2.634-7.1c1.317-3.6,1.459-4.192,1.884-5.308.211-.553.435-1.1.659-1.646.161-.441.352-.988-.115-1.248a1.433,1.433,0,0,0-1.245.138,15.8,15.8,0,0,0-1.976,1.8c-.616.629-1.159,1.317-1.758,1.976-.254.273-.553.55-.968.24s-.356-.659-.161-1.06h0a1.183,1.183,0,0,1,.122-.23c2.305-3.1,4.979-5.684,8.986-6.385a4.815,4.815,0,0,1,1.149-.148Z"
                        transform="translate(0 -138.034)"
                      />
                      <path
                        id="Path_86"
                        data-name="Path 86"
                        d="M301.2,3.594a4.192,4.192,0,0,1-5.713,3.846,3.518,3.518,0,0,1-1.867-4.248h0A4.281,4.281,0,0,1,298.3.094a3.312,3.312,0,0,1,2.9,3.5Z"
                        transform="translate(-66.577 0)"
                        fill="#00a16f"
                      />
                    </g>
                  </svg>
                  {/* <TiInfoLarge className="h-12 w-12 self-center" /> */}
                </div>
                <div className="flex flex-col gap-y-1 w-full">
                  <div className="flex text-[#00A16F] justify-between">
                    <p className="font-bold text-xs self-center">
                      {orderDetails?.robotName}
                    </p>
                    <button
                      onClick={handleOpenthree}
                      className="text-xs p-1.5 bg-[#F1F0F5] font-bold rounded"
                    >
                      VIEW INSTRUCTIONS
                    </button>
                  </div>
                  {orderDetails?.robotId && (
                    <p className="self-start font-bold text-sm">OTTOBOT</p>
                  )}
                  <p className="self-start text-sm capitalize">
                    {orderDetails?.orderStatus}
                  </p>
                </div>
              </div>
              {/* <div className="!p-4 mx-3 bg-white border-2 rounded-lg border-ottonomyBlue Congratulation-Main-wrapper_inner sm:!p-5">
              <div className="flex flex-col">
                <p className="Congratulation-Main-wrapper_p">
                  An Ottobot will be delivering your order.
                </p>
              </div>

              <div className="flex justify-center gap-[10px] congratulations_button_wrapper">
                <button
                  className="rounded-lg bg-ottonomyBlue congratulations_page_instruction_btn py-1.5 px-2.5 sm:px-[30px]"
                  onClick={handleOpenthree}
                >
                  Instructions
                </button> */}
              {/* <button
                  className="rounded-lg bg-ottonomyBlue congratulations_page_instruction_btn py-1.5 px-2.5 sm:px-[30px]"
                  onClick={handleOpenfour}
                >
                  Watch Video
                </button> */}
              {/* </div>
            </div> */}

              {/* <div className="Congratulation-page-order-wrapper-below-QR">
              <div>
                <h5>Robot</h5>
                <p> Ottobot </p>
              </div>
            </div> */}
            </div>
          </div>

          <Modal
            open={open}
            // BackdropProps={false}
            onHide={handleClose}
            // onClose={handleClose}
            backdrop="static"
            keyboard={false}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="pb-[30px] text-center">
                <div className="px-[26px] mb-[2px] flex justify-between items-center">
                  <h3 className="text-accent text-[22px]"> Scan QR Code</h3>
                  <div
                    className="Sorry_div_wrapper_inner_div"
                    style={{ paddingBottom: "0px" }}
                    onClick={handleClose}
                  >
                    <HighlightOffIcon
                      style={{ fontSize: "35px", margin: "5px" }}
                    />
                    <p className="font-bold text-[17.9px]">Close</p>
                  </div>
                </div>
                <p className="font-bold text-[17.9px] mb-3">
                  {" "}
                  Show the QR code to the camera
                </p>
                <div className="flex justify-center">
                  {generateBarCode(orderDetails?.qrcode)}
                  <img
                    id="barcode"
                    src="https://api.qrserver.com/v1/create-qr-code/?data=Congratulation&amp;size=100x100"
                    alt=""
                    title="Congratualtions"
                    width="500"
                    height="500"
                    className="!w-[300px] !h-[300px] bg-white p-[10px] mt-[19px]"
                    style={{ objectFit: "cover" }}
                  />
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={opentwo}
            onHide={handleClosetwo}
            backdrop="static"
            keyboard={false}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="pb-[30px] text-center">
                <div className="px-[26px] mb-[2px] flex justify-between items-center">
                  <h3 className="text-accent text-[22px]"> Your PIN</h3>
                  <div
                    className="Sorry_div_wrapper_inner_div"
                    style={{ paddingBottom: "0px" }}
                    onClick={handleClosetwo}
                  >
                    <HighlightOffIcon
                      style={{ fontSize: "35px", margin: "5px" }}
                    />
                    <p className="font-bold text-[17.9px]">Close</p>
                  </div>
                </div>
                <p className="font-bold text-[17.9px] mb-3">
                  {" "}
                  Enter the PIN on the Top Screen
                </p>
                <div className="flex justify-center mt-5">
                  <CustomPINDisplay
                    value={otp}
                    onChange={setInputOTP}
                    autoFocus
                    OTPLength={localStorage.getItem("pin")?.length ?? 4}
                    otpType="number"
                    disabled={false}
                    className="flex justify-center mt-5"
                    inputClassName="rounded-[5px] font-extrabold border border-gray-400"
                  />
                </div>
              </div>
            </Box>
          </Modal>

          <div className="Order_Details_div"></div>
        </div>
      </div>
      <Instruction
        openthree={openthree}
        setopenthree={setopenthree}
        handleOpenthree={handleOpenthree}
      />
      <Suspense
        fallback={
          <div style={loaderContainerStyle}>
            <style>{keyframesAnimation}</style>
            <div style={loaderStyle}></div>
          </div>
        }
      >
        {openfour && (
          <Watchvideo
            openfour={openfour}
            setopenfour={setopenfour}
            handleOpenfour={handleOpenfour}
          />
        )}
      </Suspense>
      <RemoveOrderModal
        openRemoveOrderModal={openRemoveOrderModal}
        setOpenRemoveOrderModal={setOpenRemoveOrderModal}
        deletedOrderId={orderID}
        deleteOrder={deleteOrder}
      />
      <Footer eta={Math.ceil(eta / 60)} etaLoader={etaLoader} />
    </>
  );
}

export default Congratulations;
